// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-sizer {
  outline-width: 0;
  user-select: none;
  z-index: 1;
}

.bolt-sizer:focus-within,
.bolt-sizer:hover {
  background-color: rgba( 166, 166, 166 ,  1 );
  background-color: rgba( var(--palette-neutral-30,166, 166, 166) ,  1 );
}

.bolt-sizer-active {
  background-color: rgba( 166, 166, 166 ,  1 );
  background-color: rgba( var(--palette-neutral-30,166, 166, 166) ,  1 );
  outline: 2px solid rgba( 218, 218, 218 ,  1 );
  outline: 2px solid rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}

.bolt-focus-visible .bolt-sizer {
  outline-width: 1px;
}

.bolt-sizer-column {
  cursor: ns-resize;
  padding: 2px 0;
}

.bolt-sizer-column.divider::before {
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
  content: "";
  height: 1px;
}

.bolt-sizer-row {
  cursor: ew-resize;
  padding: 0 2px;
}

.bolt-sizer-row.divider::before {
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
  content: "";
  width: 1px;
}

.bolt-sizer-portal {
  background-color: transparent;
  pointer-events: auto;
  z-index: 100;
}

.bolt-sizer-portal-column {
  cursor: ns-resize;
}

.bolt-sizer-portal-row {
  cursor: ew-resize;
}

.bolt-sizer-callout-row {
  gap: 4px;
  padding: 2px;
}

.bolt-button.bolt-sizer-resize-button {
  padding: 8px 12px;
}

/*# sourceMappingURL=Sizer.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Sizer/Sizer.scss","webpack://./../azure-devops-ui/bin/Components/Sizer/Sizer.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,iBAAA;EACA,UAAA;ACAJ;;ADGA;;EAEI,4CE2DS;ED3DX,sEAAsE;AACxE;;AAEA;EDEI,4CAAA;ECAF,sEAAsE;EACtE,6CAA6C;EDE/C,uEAAA;ACAA;;AAEA;EDEA,kBAAA;ACAA;;AAEA;EACE,iBAAiB;EDEnB,cAAA;ACAA;;AAEA;EACE,4CAA4C;EAC5C,qEAAqE;EDEvE,WAAA;EACI,WAAA;ACAJ;;AAEA;EDEA,iBAAA;EACI,cAAA;ACAJ;;AAEA;EACE,4CAA4C;EDE9C,qEAAA;EACI,WAAA;EACA,UAAA;ACAJ;;AAEA;EDEA,6BAAA;EACI,oBAAA;ECAF,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EDEI,iBAAA;ACAJ;;ADGA;EACI,QAAA;ECAF,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
